import { getObjectByKey } from "Utils/getObjectByKey"
import { stringToSlug } from "Utils/stringToSlug"

export const addDimensionsGTM = (userProfile) => {
    if (userProfile && userProfile['custom:participant_id']) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'dimension1': userProfile['custom:participant_id'],
          'dimension6': userProfile['custom:campaign_id'],
          'dimension7': userProfile['custom:catalog_id'],
          'dimension8': userProfile['custom:catalog_id']
        })
    }
}

export const getEvent = (dataLayerObject) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ ...dataLayerObject })
}
  

export const addDimensionsAddCartGTM = ( product, skuSelected, availability, quantity ) => {
  window.dataLayer = window.dataLayer || []
  const dataProduct = product;
  if (dataProduct) {
      window.dataLayer.push({
        "event": "addToCart",
        "eventCategory": "enhanced-ecommerce",
        "eventAction": "addToCart",
          'ecommerce': {
              'detail': {
              'products': [{
                  'metric2': undefined,
                  'name': stringToSlug(dataProduct?.name),
                  'id': skuSelected,
                  'price': availability?.price?.price || undefined,
                  'category': dataProduct?.subcategory ? stringToSlug(dataProduct?.subcategory?.name) : undefined,
                  "quantity": quantity
              }]
              }
          }
      })
  }
}

export const addDimensionsCartGTM = ( cartItems, step ) => {
    window.dataLayer = window.dataLayer || []
    const productsList = []
      cartItems.map((item) => {
        let categoryName
        if (item.category) {
          categoryName = item.category.name !== '' ? stringToSlug(item.category.name) : undefined
        }
        return (
          productsList.push({
            'name': stringToSlug(item.name),
            'id': item.sku,
            'price': item.price,
            'brand': undefined,
            'category': categoryName,
            'variant': undefined,
            'quantity': item.quantity,
            'coupon': undefined,
            'dimension5': item.vendor ? 'vendor-' + item.vendor.id : undefined,
            'metric2': item.cash ? item.cash.sellingPrice.toFixed(2) : undefined
          })
        )
      })
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'checkout',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': `${step}` },
            'products': productsList
          }
        }
      })
}

export const addDimensionsConfirmationGTM = (order) => {
    const purchaseType = (order && order.vendorOrderModel && order.vendorOrderModel[0].vendorType === 'Compra de Pontos') || order.paymentType === 5 ? 'resgate:points+cash' : 'resgate:points'
    const moneyValue = (order && order.vendorOrderModel && order.vendorOrderModel[0].vendorType === 'Compra de Pontos') || order.paymentType === 5 ? parseFloat(order.orderPaymentDetailMoneyAndPoints.valuePurchase.replace('.', '').replace(',', '.')) : undefined
    const orderTotalValue = (order && order.vendorOrderModel && order.vendorOrderModel[0].vendorType === 'Compra de Pontos') || order.paymentType === 5 ? undefined : order.orderTotalValue.toFixed(2)

    const productsList = []
    
    order.vendorOrderModel.map(vendorItem => {
      vendorItem.items.map((item, index) => {
        return (
          productsList.push({
            'name': item.name,
            'id': item.productSkuId,
            'price': order.paymentType === 5
              ? undefined
              : item.sellingPrice.toFixed(2),
            'brand': undefined,
            'category': item.categoryName ? stringToSlug(item.categoryName) : undefined,
            'variant': undefined,
            'quantity': item.quantity,
            'coupon': undefined,
            'dimension5': vendorItem.vendorId ? 'vendor-' + vendorItem.vendorId : undefined,
            'metric2': item.currencySellingPrice ? item.currencySellingPrice.toFixed(2) : undefined
          })
        )
      })
    })

    window.dataLayer = window.dataLayer || [];
    productsList.map((item) => {
    return window.dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'transaction_id': order.parentOrderId,
        'value': parseFloat(parseFloat(orderTotalValue).toFixed(2)),
        'tax': 0.0,
        'currency': 'BRL',
        'items': [
          {
            'item_id': item.id,
            'item_name': item.name,
            'price':  parseFloat(parseFloat(item.price).toFixed(2)),
            'item_category': item.category,
            'quantity': item.quantity,
            'item_variant': item.dimension5
          },
        ],
      },
    });
  });
}

export const addDimensionsProductGTM = ( product, skuSelected, availability ) => {
    const dataProduct = product;
    if (dataProduct) {
        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
            'event': 'productDetail',
            'eventCategory': 'enhanced-ecommerce',
            'eventAction': 'productDetail',
            'ecommerce': {
                'detail': {
                'products': [{
                    'metric2': undefined,
                    'name': stringToSlug(dataProduct?.name),
                    'id': skuSelected,
                    'price': availability?.price?.price || undefined,
                    'category': dataProduct?.subcategory ? stringToSlug(dataProduct?.subcategory?.name) : undefined
                }]
                }
            }
        })
    }
}

export const addDimensionsShowcase = (productInShowcase, arrayAvailability, showcaseName) => {
    window.dataLayer = window.dataLayer || []

    const items = [];
     productInShowcase.map((item, index) => {
      const {
        sku, name, vendor: { name: vendorName, id: vendorId },
      } = item;

      const availabilityProduct = arrayAvailability.find(product => product.sku === item.sku);
      let priceProduct = undefined;
      if (availabilityProduct?.isLoaded) {
        priceProduct = (availabilityProduct?.isAvailable && availabilityProduct?.price?.price) || undefined;
      }

      items.push(
        {
            "name": stringToSlug(name),
            "id": sku,
            "price": priceProduct,
            "position": index,
            "list": showcaseName
        }
      )
    });

    if (items.length > 0) {
      window.dataLayer.push({
        "event": "productImpressions",
        "eventCategory": "enhanced-ecommerce",
        "eventAction": "productImpression",
        "ecommerce": {
          "impressions": items
        }
    })
    }

}